/**
 * @功能名称:
 * @文件名称: store.js
 * @Date: 2018/5/21 下午5:36.
 * @Author: zhangdanqing
 * @Copyright（C）: 2014-2018 X-Financial Inc.   All rights reserved.
 * 注意：本内容仅限于小赢科技有限责任公司内部传阅，禁止外泄以及用于其他的商业目的。
 */
import {setSession, getSession} from 'bjxy-common/helper/session';
import getSmsTpl from 'bjxy-common/xyHelper/getSmsTplId'


const storage = (store) => {
  var regData = getSession('regData');
  var mobile = getSession('loginmobile');
  if (regData) {
    store.commit('login/regData', regData);
  }
  if (mobile) {
    store.commit('login/mobile', {mobile:mobile});
  }
  var timeregData = null;
  var timemobile = null;
  store.subscribe((mutation, state) => {
    if (mutation.type === 'login/regData') {
      if (timeregData) {
        clearTimeout(timeregData);
      }
      timeregData = setTimeout(function () {
        setSession('regData', state.login.regData);
      }, 50);
    }
    if (mutation.type === 'login/mobile') {
      if (timemobile) {
        clearTimeout(timemobile);
      }
      timemobile = setTimeout(function () {
        setSession('loginmobile', state.login.mobile);
      }, 50);
    }
  });
};

let store={
  login: {
    namespaced: true,
    state: {
      mobile: '',
      password: '',
      email_mob:'',
      fromUrl: '',
      isCount: false,
      contractIdList:[],
      regData: {
        isIdentityUser: '',
        realName: '',
        identityName: '',
        smsCode: '',
        identity: '',
      },
      config: {
        sourceType:'cardloan',//支付注册接口需要，传入项目名即可
        product_type:0,
        logoName:'',
        fromUrl: '',
        isShowInvite: false,
        regInviteMobile: '',
        download: 'https://cardloan.xiaoying.com/kadai/download',
        maskFindPass: false,
        noRegister: false,
        showHeader: false,
        registerText: '立即注册',
        registerRouter: 'register',
        needConfirmContract:false,
        agreements: [
          {
            title: '《小赢注册服务协议》',
            href: 'https://www.xiaoying.com/contract/staticContent?category=xiaoyingService',
          }
          ],
        xreportData:{
          login_pv:'yonghudenglu_yonghudengluye',
          login_submit:'denglu',
          find_password:'wangjimima',
          go_register:'lijizhuce',
          register_pv:'yonghuzhuce_yonghuzhuceye',
          register_back:'fanhui'
        },
        reportData: {
          register_pv: {"cmdid": 55041},
          register_mobile: '{"cmdid": 55058, "buttonid": 0}',
          register_captcha: '{"cmdid": 55058, "buttonid": 1}',
          register_getcode: '{"cmdid": 55058, "buttonid": 2}',
          register_smscode: '{"cmdid": 55058, "buttonid": 3}',
          register_password: '{"cmdid": 55058, "buttonid": 4}',
          register_submit: '{"cmdid": 55058, "buttonid": 6}',

          login_pv: {"cmdid": 55059},
          login_mobile: '{"cmdid": 55060, "buttonid": 0}',
          login_password: '{"cmdid": 55060, "buttonid": 1}',
          login_submit: '{"cmdid": 55060, "buttonid": 2}',
          login_submit_send: '',
          login_forget_text: '{"cmdid": 55060, "buttonid": 3}',
          login_register_text: '{"cmdid": 55060, "buttonid": 4}',
          login_show_password: {"cmdid": 55060, "buttonid": 5},
          login_hide_password: {"cmdid": 55060, "buttonid": 6}
        },
        loginMobile: '手机',
        loginPassword: '密码',
        findMobile: '输入手机号',
        findSmsCode: '输入短信验证码',
        findIdentity: '请填写实名认证时的身份证号',
        findNewPass: '新密码',
        findNewPassConfirm: '确认新密码',
        //  显示小赢客服电话 boolean
        showServicePhone: false,
        showBottomWarning: false,
        sceneId:'userRegister',//注册协议默认sceneId，得意花为dyhUserRegister,
        partnerName:'',//请求合同需要
        isSecretFreeRegistration:false,//是否免密登录，默认不免密
        isCallPayInterface:true,//默认为true
        smsTplId: '10001150',
        smsTplVersion: '4',
        isShowFindPassword:true,
        isShowLoginText:true
      },
    },
    mutations: {
      mobile(state, payload) {
        state.mobile = payload.mobile;
      },
      password(state, payload) {
        state.password = payload.password;
      },
      fromUrl(state, payload) {
        if(/^http(s)?:\/\/(\w)+\.(xiaoying|yingzt)\.com([/?#]|$)/gm.test(payload.fromUrl)){
          state.fromUrl = payload.fromUrl;
        }
        // 核心组客服功能跳转
        if(/^http(s)?:\/\/(\w)+\.(xiaoying\.cn)|(oa\.com)([/?#]|$)/gm.test(payload.fromUrl)){
          state.fromUrl = payload.fromUrl;
        }
      },
      regData(state, payload) {
        Object.assign(state.regData, payload);
      },
      isCount(state, payload) {
        state.isCount = payload.isCount;
      },
      email_mob(state, payload) {
        state.email_mob = payload.email_mob;
      },
      contractIdList(state, payload){
        state.contractIdList = payload;
      }
    },
  },
}
let plugins=[storage];
export {store , plugins}
